import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  buttonGroup: {
    transition: 'none',
    borderRadius: theme.borderRadius.md,
    border: 'none',
    boxShadow: 'none !important',

    '& .MuiButtonBase-root.MuiButton-root': {
      borderWidth: 0,
    },
  },
}));

export default useStyles;
